module.exports = __webpack_public_path__ + "img/InstagramSans-Regular.cc936eb4.svg";